export default __webpack_public_path__ + "static/media/LandingPageBg.dff94bb6.png";